import { Component, OnInit, Input } from '@angular/core';
import { PostAttachments } from 'src/app/_models';
import { BaseComponent } from 'src/app/_base/base.component';
import { PostImageViewComponent } from '../modal/post-image-view/post-image-view.component';
import { customModalXLConfigurationWithBackClickClose } from 'src/app/_configs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-post-images-viewer',
  templateUrl: './post-images-viewer.component.html',
  styleUrls: ['./post-images-viewer.component.scss']
})
export class PostImagesViewerComponent extends BaseComponent implements OnInit {
  @Input()
  postImages: PostAttachments[] = [];
  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) {
    super();
  }

  ngOnInit() {}
  getPostImage(image: string): string {
    return this.getImage(image);
  }
  openFullView(postIndex: number): void {
    const initialState: { postIndex: number; postImages: PostAttachments[] } = { postIndex, postImages: this.postImages };
    this.modalRef = this.modalService.show(PostImageViewComponent, {
      ...customModalXLConfigurationWithBackClickClose,
      initialState
    });
  }
}
